import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

export const StatCounter = ({ value, label, testId }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let raf;
    const duration = 1600;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(eased * value));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);

  return (
    <div ref={ref} data-testid={testId} className="text-center">
      <div className="font-heading font-extrabold text-5xl sm:text-6xl lg:text-7xl text-white tracking-tight tabular-nums">
        {display}
        <span className="text-emerald-brand">+</span>
      </div>
      <p className="mt-3 text-sm uppercase tracking-[0.18em] text-white/55">{label}</p>
    </div>
  );
};
